import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './Skill.css';
import NavBarShan from '../NavBar/NavBar';
import LoadingLoggedIn from '../Loading/Loading';

class SkillPageDet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      SkillPageUrl: 'https://my-webpage-node.vercel.app/Skill/PercentData',
      SkillPageParaUrl: 'https://my-webpage-node.vercel.app/Skill/ParaData',
      skillPageExperienceUrl: 'https://my-webpage-node.vercel.app/Skill/Experience',
      SkillPageData: [],
      SkillPageParaData: [],
      skillPageExperienceData: [],
      SkillPageDataLoading: false,
      SkillPageParaDataLoading: false,
      skillPageExperienceDataLoading: false,
      line1: 'Skills',
      textAnimationLine1: [],
      editPopUp: false,
      editPopUpData: {}
    }
  }

  async componentDidMount() {
    let tempArr1 = []
    this.props.SelectedPage('LoggedInPage', {
      SelectedPage: 2
    })
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      editPopUpData: {}
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.SkillPageDataLoading && this.state.SkillPageParaDataLoading && this.state.skillPageExperienceDataLoading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    await axios.get(this.state.SkillPageParaUrl).then((res) => {
      this.setState({
        SkillPageParaDataLoading: true,
        SkillPageParaData: res.data
      })
    }).catch((err) => {
      console.log(err)
      this.setState({
        SkillPageParaDataLoading: false
      })
    })
    await axios.get(this.state.SkillPageUrl).then((res) => {
      this.setState({
        SkillPageDataLoading: true,
        SkillPageData: res.data
      })
    }).catch((err) => {
      console.log(err)
      this.setState({
        SkillPageDataLoading: false
      })
    })
    await axios.get(this.state.skillPageExperienceUrl).then((res) => {
      this.setState({
        skillPageExperienceDataLoading: true,
        skillPageExperienceData: res.data
      })
    }).catch((err) => {
      console.log(err)
      this.setState({
        skillPageExperienceDataLoading: false
      })
    })
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    return (<>
      <div className='LoggedInCommonDiv'>
        <NavBarShan />
        {this.state.SkillPageDataLoading && this.state.SkillPageParaDataLoading && this.state.skillPageExperienceDataLoading ?
          <div className='LoggedInSideDiv'>
            <div className='SkillPageHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='AboutAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'AboutAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'AboutAniLetterMouse AboutAniLetter' : 'AboutAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <table className='SkillPageLoggedInTbl'>
              <thead>
                <tr>
                  <th className='SkillPagepd20 SkillPageLoggedInTblBrd'>ID No</th>
                  <th className='SkillPagepd20 SkillPageLoggedInTblBrd'>Role Description</th>
                  <th className='SkillPagepd20 SkillPageLoggedInTblBrd'>Option</th>
                </tr>
              </thead>
              <tbody>
                {/* {this.state.SkillPageData.map((ite, index) => {
                                    return (<>
                                        <tr>
                                            <td className='SkillPagepd20 SkillPageLoggedInTblBrd'>{ite?._id}</td>
                                            <td className='SkillPagepd20 SkillPageLoggedInTblBrd'>{ite?.role}</td>
                                            <td className='SkillPagepd20 SkillPageEditBtn SkillPageLoggedInTblBrd' onClick={() => {
                                                this.setState({
                                                    editPopUpData: ite,
                                                    editPopUp: true
                                                })
                                            }}>Edit</td>
                                        </tr>
                                    </>)
                                })} */}
              </tbody>
            </table>
          </div> :
          <LoadingLoggedIn />}
        {this.state.editPopUp ?
          <div className='SkillPageEditDataPopUpLoggedIn'>
          </div>
          : ''}
      </div>

    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SkillPageDet));